import reduxStore from "../../configureEnvStore";
import { CALL_BODY_SCREEN, DEVICE_TYPES, DISABLE, ENABLED } from "../../constants/Constants";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { setAllowMarkup, setAllowPointer, setAllowTakePhoto, setCurrentCallBodyScreen, setExpandView } from "../../reducers/common-reducer";
import {
    setScreenshareIdentityParticipantVise,
    setStreamingPartiIdentity,
    setVideoIdentityParticipantVise,
} from "../../reducers/twilioEvents-reducer";
import { setPinForScreenShare } from "../../reducers/gallery-view-reducer";
import { LogFirebase } from "../../services/firestore";
import zoomService from "../../services/zoomService";
import { getLocalPartiName, getParticipantIndex, sendDataTrack } from "../../shared/dataTrackFunction";
import { expandViewEnabled, getUserDetailsById, isParticipantStreaming, setStreamingPartiDetails } from "../Twilio/Room/roomFunction";
import { showLatLongForStreaming } from "../LiveLocation/LocationUtils";
import { checkLivePointerOn } from "../LivePointer/LivePointerUtils";
import livePointerService from "../LivePointer/livePointerService";
import { isLiveStreamFeatureSupported } from "../Markup/MarkupFunction";
import {
    attachTracks,
    getPublishVideoContainer,
    getVideoContainer,
    getTracksByType,
    removeVideoElement,
    restartLocalVideoTracks,
} from "../Twilio/twilioCallUtility";
import { addVideoPausedCheck, getVideoTracksByIdentity, playIfVideoIsPaused } from "../Twilio/VideoCall/VideoUtils";
import { dualStreamEnabled } from "../../shared/utility";
import { getLocalVideoTrack, getScreenShareLocalTrack, getRoom } from "../Twilio/Room/roomService";
import flashService from "../../services/flashService";

export const sendExpandChangeMsg = function (identity, action, deviceType) {
    let msg;
    if (action == "expand") {
        msg = {
            notification_type: NOTIFICATION_TYPES.MULTI_STREAM.EXPAND,
            sender_identity: CALL_DATA.localIdentity,
            expand_useridentity: identity,
            device_type: GLOBAL_MEETING_DATA.device_type,
        };
        if (deviceType) {
            msg.expand_device_type = deviceType;
        }
    } else {
        msg = {
            notification_type: NOTIFICATION_TYPES.MULTI_STREAM.COLLAPSE,
            sender_identity: CALL_DATA.localIdentity,
            collapse_useridentity: identity,
            device_type: GLOBAL_MEETING_DATA.device_type,
        };
    }
    LogFirebase("MultiStream", "SendMsg_" + action, msg);
    sendDataTrack(msg);
};

export const checkMarkupOCRbutton = (identity, isScreenShare, userDetails) => {
    const { device_type } = userDetails;

    const enableFeatures = (allowMarkup, allowTakePhoto, allowPointer) => {
        reduxStore.dispatch(setAllowMarkup(allowMarkup));
        reduxStore.dispatch(setAllowTakePhoto(allowTakePhoto));
        reduxStore.dispatch(setAllowPointer(allowPointer));
    };

    if (!isScreenShare) {
        enableFeatures(true, true, true);
    } else if (isParticipantStreaming(identity)) {
        switch (device_type) {
            case DEVICE_TYPES.DESKTOP:
                enableFeatures(true, true, true);
                break;
            case DEVICE_TYPES.ANDROID_APP:
                enableFeatures(true, true, isLiveStreamFeatureSupported(userDetails));
                break;
            case DEVICE_TYPES.IOS_APP:
                enableFeatures(false, false, false);
                break;
            default:
                enableFeatures(false, false, false);
                break;
        }
    }
};

export const toggleActionButtonsOnExpand = (identity, isScreenShare, from) => {
    const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
    const userDetails = getUserDetailsById(streamingPartiIdentity);
    checkMarkupOCRbutton(identity, isScreenShare, userDetails);
};

export const attachTracksToVideoElement = (participantIdentity, retries) => {
    setTimeout(() => {
        const trackArray = getVideoTracksByIdentity(participantIdentity);
        const expandViewElement = document.getElementById("expandedVideo");
        if (expandViewElement) {
            attachTracks(trackArray, expandViewElement, "fromCallBack", function () {
                if (participantIdentity == CALL_DATA.localIdentity && flashService.shouldRestartLocalVideoTracksForIOSDeviceAndSafari()) {
                    restartLocalVideoTracks();
                    LogFirebase("MultiStream", "in expand View", "restartLocalVideoTracks");
                }
            });
        } else if (retries > 0) {
            attachTracksToVideoElement(participantIdentity, retries);
        } else {
            LogFirebase("MultiStream", "VideoElement", "Container not found after multiple attempts.");
            console.error("Container not found after multiple attempts.");
        }
    }, 100);
};

export const screenShareOnOffStatus = (msg) => {
    if (msg.status == ENABLED) {
        const currentScreenShares = reduxStore.getState().twilioEvents.screenshareIdentityParticipantVise;
        // Check if identity already exists
        const identityExists = currentScreenShares.some((user) => user.identity === msg.identity);

        if (!identityExists) {
            // Append new entry while keeping existing ones
            reduxStore.dispatch(
                setScreenshareIdentityParticipantVise([
                    ...currentScreenShares,
                    { identity: msg.identity, isiOSScreenShareUser: msg.isiOSScreenShareUser },
                ])
            );
        }
    } else if (msg.status == DISABLE) {
        const currentScreenShares = reduxStore.getState().twilioEvents.screenshareIdentityParticipantVise;

        // Remove the identity from the array
        const updatedScreenShares = currentScreenShares.filter((user) => user.identity !== msg.identity);

        reduxStore.dispatch(setScreenshareIdentityParticipantVise(updatedScreenShares));
    }
};

export const videoOnOffStatus = (msg) => {
    if (msg.status == ENABLED) {
        const currentUsersVideoIdentity = reduxStore.getState().twilioEvents.videoIdentityParticipantVise;
        // Check if identity already exists
        const identityExists = currentUsersVideoIdentity.some((user) => user.identity === msg.identity);

        if (!identityExists) {
            // Append new entry while keeping existing ones
            reduxStore.dispatch(setVideoIdentityParticipantVise([...currentUsersVideoIdentity, { identity: msg.identity }]));
        }
    } else if (msg.status == DISABLE) {
        const currentUsersVideoIdentity = reduxStore.getState().twilioEvents.videoIdentityParticipantVise;

        // Remove the identity from the array
        const updatedVideoIdentity = currentUsersVideoIdentity.filter((user) => user.identity !== msg.identity);

        reduxStore.dispatch(setVideoIdentityParticipantVise(updatedVideoIdentity));
    }
};

export const showExpandView = (participantIdentity, sendNotification) => {
    const { expandView } = reduxStore.getState().commonReducer;
    if (!expandView) {
        //// callSettingModelClose

        const isScreenShare = reduxStore.getState().twilioEvents.videoStreamingUsers?.includes(participantIdentity);
        reduxStore.dispatch(setPinForScreenShare(!isScreenShare));
        reduxStore.dispatch(setStreamingPartiIdentity(participantIdentity));
        setStreamingPartiDetails(participantIdentity);
        const { callParticipants } = reduxStore.getState().commonReducer;
        let deviceType = null;
        callParticipants.forEach((user) => {
            if (user.identity == participantIdentity) {
                deviceType = user.device_type;
            }
        });
        if (sendNotification) {
            LogFirebase("MultiStream", "AgentExpandedScreen", participantIdentity);
            sendExpandChangeMsg(participantIdentity, "expand", deviceType);
        }

        let partiName = getParticipantIndex(participantIdentity);
        if (participantIdentity == CALL_DATA.localIdentity) {
            partiName = getLocalPartiName();
        }
        console.log(partiName);
        reduxStore.dispatch(setExpandView(true));
        reduxStore.dispatch(setCurrentCallBodyScreen(CALL_BODY_SCREEN.VIDEO_SCREEN));
        ////required to set stream as per streaming user
        //// $rootScope.changeVideoViewScale();

        showLatLongForStreaming();
        LogFirebase("MultiStream", "ScreenExpanded", participantIdentity);
        attachTracksToVideoElement(participantIdentity, 5);

        /* markup,ocr,live pointer status enable/disable for dual stream will be handled */
        /* isScreenShare=false means video true */
        toggleActionButtonsOnExpand(participantIdentity, !isScreenShare, "multiStream");

        // Auto live pointer activation for dual stream expand view
        if (dualStreamEnabled() && livePointerService.isAutoLivePointerEnabled() && GLOBAL_MEETING_DATA.isAgent) {
            // Wait for video to be ready before activating auto pointer
            livePointerService.waitForVideoReadyThenExecute(() => {
                // Get video tracks for the expanded participant
                const room = getRoom();
                let trackArr = [];

                if (participantIdentity === CALL_DATA.localIdentity) {
                    // Local participant - no remote tracks needed
                    trackArr = [];
                } else {
                    // Remote participant - get their video tracks
                    room?.participants?.forEach((remoteParticipant) => {
                        if (remoteParticipant.identity === participantIdentity) {
                            trackArr = getTracksByType(remoteParticipant, "video");
                        }
                    });
                }

                livePointerService.checkAutomaticLivePointerOnExpandCollap(trackArr);
            });
        }

        setTimeout(() => {
            if (PublicVariables.isIOSDevice) {
                playIfVideoIsPaused(); // not needed participantIdentity due to expand view
                addVideoPausedCheck.start(); // add interval to check video pause
            }
        }, 1000);
    }
};

export const showGridView = (identity, sendNotification) => {
    const { expandView } = reduxStore.getState().commonReducer;
    if (expandView) {
        if (sendNotification) {
            LogFirebase("MultiStream", "AgentCollapsedScreen", identity);
            sendExpandChangeMsg(identity, "collapse");
            checkLivePointerOn();
        }
        reduxStore.dispatch(setStreamingPartiIdentity(null));
        setStreamingPartiDetails(null);
        reduxStore.dispatch(setExpandView(false));
        reduxStore.dispatch(setCurrentCallBodyScreen(CALL_BODY_SCREEN.GALLERY_VIEW));

        //// $(expandViewElement).find("#latlong").remove();

        /* remove video from expanded container, slick gallery and attach back into grid view */
        setTimeout(() => {
            const expandViewElement = document.getElementById("expandedVideo");
            removeVideoElement(expandViewElement);
            attachVideoTracksIntoGrid();
        }, 100);
        zoomService.callResetZoom();

        /* disable expand button for few seconds */

        LogFirebase("MultiStream", "ScreenCollapsed", identity);
    } else {
        console.log("::already in grid view");
    }
};

export const manageScreenShareinMultiStream = (participantIdentity) => {
    let processingGridView = false;
    if (GLOBAL_MEETING_DATA.isAgent) {
        if (expandViewEnabled()) {
            processingGridView = true;
            showGridView(participantIdentity, true);
        } else {
            //no expanded stream
            console.log("no expanded view");
        }
        if (processingGridView) {
            setTimeout(() => {
                LogFirebase("MultiStream", "ScreenShareOn", participantIdentity);
                showExpandView(participantIdentity, true);
            }, 500);
        } else {
            //no need to wait for a sec
            LogFirebase("MultiStream", "ScreenShareOn", participantIdentity);
            showExpandView(participantIdentity, true);
        }
        //require to handle multiple ss
        sendExpandChangeMsg(participantIdentity, "expand", ""); //mweb
    } else {
        //guest will just start screen share
        console.log("guest will just start screen share");
    }
};

export const getLocalVideoOrScreenShareTrack = () => {
    return getScreenShareLocalTrack() ? getScreenShareLocalTrack() : getLocalVideoTrack();
};

export const attachVideoTracksIntoGrid = () => {
    const room = getRoom();
    const localtracks = getLocalVideoOrScreenShareTrack();
    if (localtracks) {
        const localContainer = getPublishVideoContainer();
        if (localContainer?.querySelector("video")) {
            LogFirebase("TwilioEvents", "VideoAlreadyExistInGrid", localContainer?.id);
        } else {
            attachTracks([localtracks], localContainer, "fromCallBack", function () {
                if (flashService.shouldRestartLocalVideoTracksForIOSDeviceAndSafari()) {
                    restartLocalVideoTracks();
                    LogFirebase("MultiStream", "attach tracks in Grid", "restartLocalVideoTracks");
                }
            });
        }
    }
    room?.participants?.forEach(function (remoteParticipant, val) {
        if (remoteParticipant.videoTracks.size > 0) {
            const container = getVideoContainer(remoteParticipant.identity);
            if (container?.querySelector("video")) {
                LogFirebase("TwilioEvents", "VideoAlreadyExistInGrid", container?.id);
            } else {
                const trackArr = getTracksByType(remoteParticipant, "video");
                console.log("trackArr____: ", trackArr, "container___:", container);
                attachTracks(trackArr, container);
            }
        }
    });
};

export const attachVideoTracksStreamingIdentityVise = () => {
    const streamingPartiIdentity = reduxStore.getState().twilioEvents.streamingPartiIdentity;
    const expandView = reduxStore.getState().commonReducer.expandView;
    const room = getRoom();
    const localtracks = getLocalVideoOrScreenShareTrack();
    const shouldAttachLocalTracks = expandView ? localtracks && streamingPartiIdentity === CALL_DATA.localIdentity : !!localtracks;
    if (shouldAttachLocalTracks) {
        const localContainer = expandView ? document.getElementById("expandedVideo") : getPublishVideoContainer();
        if (localContainer?.querySelector("video")) {
            LogFirebase("TwilioEvents", "VideoAlreadyExistInGrid", localContainer?.id);
        } else {
            attachTracks([localtracks], localContainer, "fromCallBack", function () {
                if (flashService.shouldRestartLocalVideoTracksForIOSDeviceAndSafari()) {
                    restartLocalVideoTracks();
                    LogFirebase("MultiStream", "attach tracks in Grid", "restartLocalVideoTracks");
                }
            });
        }
    }
    room?.participants?.forEach(function (remoteParticipant, val) {
        const shouldAttachRemoteTracks = expandView
            ? remoteParticipant.videoTracks.size > 0 && streamingPartiIdentity === remoteParticipant.identity
            : remoteParticipant.videoTracks.size > 0;

        if (shouldAttachRemoteTracks) {
            const container = expandView ? document.getElementById("expandedVideo") : getVideoContainer(remoteParticipant.identity);
            if (container?.querySelector("video")) {
                LogFirebase("TwilioEvents", "VideoAlreadyExistInGrid", container?.id);
            } else {
                const trackArr = getTracksByType(remoteParticipant, "video");
                console.log("trackArr____: ", trackArr, "container___:", container);
                attachTracks(trackArr, container);
            }
        }
    });
};
